import React from 'react'
import ReactGA from 'react-ga'
import { isEmpty, min } from 'lodash'
import InfiniteScroll from 'react-infinite-scroller'
import { Grid } from '@material-ui/core'
import ShareIcons from './ShareIcons'
import EmptyList from './EmptyList'
import CircularLoading from './loadings/CircularLoading'
import { styles } from '../styles/js/photosList'
import { withStyles } from '@material-ui/core'

const PhotosListComponent = ({
  classes,
  setDialogPhoto,
  photosState,
  photos,
  statusRequestPhotos,
  fetchPhotos,
  searchParams,
  pageProps,
}) => {
  return photosState.length > 0 ? (
    statusRequestPhotos.isLoading && !isEmpty(searchParams) ? (
      <CircularLoading />
    ) : (
      <InfiniteScroll
        pageStart={0}
        loadMore={() => {
          if (
            statusRequestPhotos.done &&
            !statusRequestPhotos.isLoading &&
            isEmpty(searchParams)
          ) {
            fetchPhotos()
            ReactGA.event({
              category: 'User',
              action: 'Fetched next page',
            })
          }
        }}
        hasMore={photosState.length < min([photos.count, 600])}
        loader={
          <div key={0} style={{ marginTop: 40 }}>
            <CircularLoading />
          </div>
        }
        threshold={1000}
      >
        <Grid container spacing={2} justifyContent='center'>
          {photosState.map(
            photo =>
              photo.telespectador && (
                <Grid key={photo.id} item xs={6} sm={4}>
                  <div
                    className={classes.photoZoom + ' photo-zoom'}
                    onClick={() =>
                      setDialogPhoto({ isOpen: true, data: photo })
                    }
                  >
                    <img
                      alt={photo.telespectador}
                      src={photo.resizedUrl}
                      className={classes.photo}
                    />

                    <div className={'hover-bar'}>
                      <ShareIcons
                        size={'2x'}
                        justify='space-evenly'
                        color='#fff'
                        photoParam={`?foto=${photo.id}`}
                        telespectador={photo.telespectador}
                        mobileXs
                        pageProps={pageProps}
                      />
                    </div>
                  </div>
                </Grid>
              )
          )}
        </Grid>
      </InfiniteScroll>
    )
  ) : statusRequestPhotos.isLoading && photosState.length === 0 ? (
    <CircularLoading />
  ) : (
    <EmptyList />
  )
}

export default withStyles(styles)(PhotosListComponent)
